<div rds-dialog-header>
  <h2 rds-dialog-title>{{ POPUPS.BEST_PRACTICE.TITLE }}</h2>
</div>
<div rds-dialog-content [formGroup]="form" class="dialog-form">
  <rds-form-field labelPosition="top">
    <rds-control-label>{{
      POPUPS.BEST_PRACTICE.TITLE_LABEL
    }}</rds-control-label>
    <input rdsInput formControlName="title" />
    @if (form.controls.title.touched && form.controls.title.errors) {
      <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
    }
  </rds-form-field>
  <div class="dialog-description">
    <rds-control-label
      >{{ POPUPS.BEST_PRACTICE.DESCRIPTION_LABEL }}
      <span class="rich-editor-field-asterisk"> * </span>
    </rds-control-label>
    <app-rich-text-editor
      formControlName="description"
      [placeholder]=""
      [readonly]="false"
      [minHeight]="400"
      [invalid]="
        form.controls.description.touched && form.controls.description.invalid
      "
    >
    </app-rich-text-editor>
    @if (
      form.controls.description.touched && form.controls.description.invalid
    ) {
      <div class="editor-error">
        <rds-icon namespace="outlined" icon="warning_circle"></rds-icon>
        <span>{{ ERRORS.EMPTY }}</span>
      </div>
    }
  </div>
</div>
<div rds-dialog-actions-container>
  <button rds-secondary-button [rds-dialog-close]="false" size="m">
    {{ BUTTONS.CANCEL }}
  </button>
  <button
    rds-primary-button
    size="m"
    (click)="submit()"
    [disabled]="form.invalid"
  >
    {{ BUTTONS.ADD }}
  </button>
</div>
